import { getMonthYearFromDate, getRangePlanificated, getRangeReal, isBefore, isSame, numberFormatter } from "../utils/helperFunctions"
import moment from "moment"
import { IScenario } from "../models/ScenarioModel"

export const URI_LOCAL = process.env.REACT_APP_API_URI_LOCAL
export const ACCESS_TOKEN = process.env.REACT_APP_ACCESS_TOKEN
export const EDIT_TYPES = {
    number:0,
    boolean:1,
    icon:2,
    object:3,
    date:4,
    autocomplete:5
}
export const HOME_PERMISSIONS = {
    C: [1],
    R: [1,2,3,4,6],
    U: [1],
    D: [1],
}
export const RECOVERY_PERMISSIONS = {
    C: [1],
    R: [1,2,3,4,6],
    U: [1],
    D: [1],
}
export const VISUALIZACION_PERMISSIONS = {
    C: [1],
    R: [1,2,3,4,6],
    U: [1],
    D: [1],
}
export const LANZAMIENTOS_PERMISSIONS = {
    C: [1],
    R: [1,2,3,4,6],
    U: [1],
    D: [1],
}
export const ERRORES_PERMISSIONS = {
    C: [1],
    R: [1,2,3,4,6],
    U: [1],
    D: [1],
}
export const ADMIN_PERMISSIONS = {
    C: [1],
    R: [1],
    U: [1],
    D: [1],
    
}

export const INITIAL_STATE_SCENARIO:IScenario = {
  id_scenario: 1,
  name_scenario: "",
  id_plant: 1,
  name_plant: "",
  id_planner: 1,
  name_planner: "",
  settings: {
      provider : {
          provider_table: [],
          contract_table: []
      },
      warehouse : {
          provider_table: [],
          warehouse_table: []
      },
      shipping : {
          shipping_km_table : [],
          shipping_month_table : [],
          shipping_plant_table: []
      },
      precipitation: {
          precipitation_map: {},
          precipitation_table: []
      },
      energy_consumption:[]
  }
}

const formatCustom = (val:any, opt:any) => {
  const goals = opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex].goals
  if (goals && goals.length) {
    return val
  }
  return numberFormatter(val) 
}

const colorsCustom = (params:any) => {
  let serie = params.seriesIndex
  let mes = params.dataPointIndex
  let meses = params.w.config.xaxis.categories
  let fecha_planificado = params.w.config.series[serie].planned_date
  let fecha_formateada = getMonthYearFromDate(fecha_planificado)
        
  if(isBefore(meses[mes],fecha_formateada)) {
    if(serie === 0) {
      return 'rgba(10,10,44,0.3)'
    } else {
      return 'var(--lis-alternative)'
    }
  } else {
    if(serie === 0) {
      return 'var(--lis-dark)'
    } else {
      return 'var(--lis-alternative)'
    }
  }
}

const returnDefaultTables = (type:string,a:any,w:any,seriesIndex:any,dataPointIndex:any,conflict?:any) => {
  switch(type) {
    case 'warehouse':
      return (
        '<tr style="border:1px solid #ddd;padding:1px;font-size:12px">' +
        '<td style="border:1px solid #ddd;padding:1px;">' + a[type] + '</td>' +
        '<td style="border:1px solid #ddd;padding:1px;">' + numberFormatter(a.value) + '</td>' +
        '<td style="border:1px solid #ddd;padding:1px;">' + numberFormatter((a.value / w.config.series[seriesIndex].data[dataPointIndex]) * 100) + '%</td>' +
        '</tr>'
      );
  
    case 'provider':
    case 'transportista':
      if(conflict) {
        return (
          '<tr style="border:1px solid #ddd;padding:1px;font-size:12px">' +
          '<td style="border:1px solid #ddd;padding:1px;">' + a[type] + '</td>' +
          '<td style="border:1px solid #ddd;padding:1px;">' + numberFormatter(a.value) + '</td>' +
          '<td style="border:1px solid #ddd;padding:1px;">' + numberFormatter((a.value / w.config.series[seriesIndex].data[dataPointIndex]) * 100) + '%</td>' +
          '<td style="border:1px solid #ddd;padding:1px;">' + a.categoria + '</td>' +
          '</tr>'
        );
      }
      return (
        '<tr style="border:1px solid #ddd;padding:1px;font-size:12px">' +
        '<td style="border:1px solid #ddd;padding:1px;">' + a[type] + '</td>' +
        '<td style="border:1px solid #ddd;padding:1px;">' + numberFormatter(a.value) + '</td>' +
        '<td style="border:1px solid #ddd;padding:1px;">' + numberFormatter((a.value / w.config.series[seriesIndex].data[dataPointIndex]) * 100) + '%</td>' +
        '</tr>'
      );
  }
}


export const STATE_ENTREGAS_OPERATIVO_INITIAL_STATE = {
          
  series: [],
  options: {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false
      },
      
    },
    
    title : {
      text: "Stock Total en Planta (Tm)",
      style : {
        fontSize: '14px',
        fontFamily: 'var(--roboto-medium)'
      }
      },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        borderRadius: 5,
        dataLabels: {
          position:'top'
        },
      stacked:true,
      },
      
    },
    colors:[
      function(params:any,w:any) {
        
        let semana = params.dataPointIndex
        
        let semanas = params.w.config.xaxis.categories
       
        let current_semana = semanas[semana].length === 2? parseInt(semanas[semana].slice(2)) : parseInt(semanas[semana].slice(1))
        
        if(moment().week() === current_semana ) {
          return '#00FFFF'
        } 
        return 'var(--lis-dark)'
        
      }
    ],
    dataLabels: {
      enabled: false,
      formatter : function (val:any,opts:any) {
        return numberFormatter(val)
      },
      offsetY: -25,
      
      style : {
        colors: ['var(--lis-dark)','var(--lis-alternative)'],
        
      },
      background: {
        enabled: true,
        
        borderRadius: 2,
        padding: 4,
        opacity: 0.5,
        borderWidth: 2,
        borderColor: 'var(--lis-dark)'
      },
      
      

    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18','W19','W20','W21','W22','W23','W24','W25','W26','W27','W28','W29','W30','W31','W32','W33','W34','W35','W36','W37','W38','W39','W40','W41','W42','W43','W44','W45','W46','W47','W48','W49','W50','W51','W52'],
      labels: {
        style : {
          fontSize: '10px',
          fontFamily: 'var(--roboto-medium)'
        }
      }
    },
    yaxis: {
      labels : {
        formatter : function (value:any) {
          return numberFormatter(value)
        },
      },
      title: {
        text: 'Cantidad',
        style : {
          fontSize: '12px',
          fontFamily: 'var(--roboto-medium)'
        }
      }
    },
    fill: {
      opacity: 1
    },
    legend : {
      show: true,
      showForSingleSeries: true,
      position:'top',
      fontFamily:'var(--roboto-medium)',
      markers : {
        
        strokeColor:'black',
        radius:5,
        fillColors: ['red'],
        
      },
      onItemClick : {
        toggleDataSeries:false
      },
      onItemHover : {
        highlightDataSeries:false
      },
      
      formatter : function (value:any) {
        return "Semana actual"
      }
    },
    tooltip: {
      custom: function({series, seriesIndex, dataPointIndex, w}:any) {
     
        let localizacion = w.config.aux[dataPointIndex]
        console.log(series)
        let color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
        return '<div class="arrow_box" style="width:175px;height:115px;display:flex;justify-content:center;align-items:center;flex-direction:column;font-family:var(--roboto-medium)">' +
          '<span style="flex:0.75;display:flex;justify-content:center;align-items:center;background-color:'+ color +';width:100%;color:white">Stock Total</span>' +
          '<div style="flex:2;display:flex;justify-content:center;align-items:flex-start;flex-direction:column">' +
            '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0" >- Semana: ' + localizacion[seriesIndex].semana + '</span>' +
            '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0" >- Valor: ' + numberFormatter(localizacion[seriesIndex].value) + '</span>' +
          '</div>'
      },
    
      style : {
        fontSize: '14px',
        fontFamily: 'var(--roboto-medium)'
      }
    },
  },


}

export const STATE_ENTREGAS_INITIAL_STATE = {
          
    series: [],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false
        },
        
      },
      
      title : {
        text: "Mix Biomasa en Planta (Tm)",
        style : {
          fontSize: '14px',
          fontFamily: 'var(--roboto-medium)'
        }
        },
      plotOptions: {
        
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded',
          borderRadius: 5,
          dataLabels: {
            position:'top'
          },
        stacked:true,
        },
        /*'var(--lis-dark)','var(--lis-alternative)','#301934''#DCA123','#EEW923'*/
      },
      colors:[
        (params:any) => colorsCustom(params)

        
        
      ],
      dataLabels: {
        enabled: true,
        formatter : function (val:any,opts:any) {
          return numberFormatter(val)
        },
        offsetY: -25,
        
        style : {
          colors: ['var(--lis-dark)','var(--lis-alternative)'],
          
        },
        background: {
          enabled: true,
          
          borderRadius: 2,
          padding: 4,
          opacity: 0.5,
          borderWidth: 2,
          borderColor: 'var(--lis-dark)'
        },
        
        

      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Ago 22','Sep 22','Oct 22','Nov 22','Dic 22','En 23', 'Feb 23', 'Mar 23', 'Abr 23', 'May 23','Jun 23', 'Jul 23'],
        labels: {
          
          style : {
            fontSize: '10px',
            fontFamily: 'var(--roboto-medium)'
          }
        }
      },
      yaxis: {
        labels : {
          formatter : function (value:any) {
            return numberFormatter(value)
          }
        },
        title: {
          text: 'Cantidad',
          
          style : {
            fontSize: '12px',
            fontFamily: 'var(--roboto-medium)'
          }
        }
      },

      fill: {
        
        opacity:1
      },

      legend : {
        fontSize: '12px',
        fontFamily: 'var(--roboto-light)',
        markers: {
          fillColors: ['var(--lis-dark)','var(--lis-alternative)'], 
      },
      },
      
      tooltip: {
        followCursor:false,
        custom: function({series, seriesIndex, dataPointIndex, w}:any) {
          
            let serie = seriesIndex
            let mes = dataPointIndex
            let meses = w.config.xaxis.categories
            let fecha_planificado = w.config.series[serie].planned_date
            let fecha_formateada = getMonthYearFromDate(fecha_planificado)
    
            let titleReal = getRangeReal(fecha_planificado)
            let titlePlan = getRangePlanificated(fecha_planificado)
                
            if(isSame(meses[mes],fecha_formateada)) {
            
              let localizacion = w.config.series[seriesIndex].aux
              
              let reales:any = {};
                for (let key in localizacion[dataPointIndex]) {
                  if (key.includes("(real)")) {
                    reales[key] = localizacion[dataPointIndex][key];
                  }
                }
              let planificados:any = {};
                for (let key in localizacion[dataPointIndex]) {
                  if (key.includes("(planificado)")) {
                    planificados[key] = localizacion[dataPointIndex][key];
                  }
                }

              
              let localizacion_total_reales = reales['pabellon (real)'] + reales['pajera (real)'] + reales['prov (real)']
              let localizacion_total_planificados = planificados['pabellon (planificado)'] + planificados['pajera (planificado)'] + planificados['prov (planificado)']

              let color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
              let real_color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
              return '<div class="arrow_box" style="width:500px;height:115px;display:flex;justify-content:flex-start;align-items:center;flex-direction:column;font-family:var(--roboto-medium)">' +
                '<span style="flex:0.75;display:flex;justify-content:center;align-items:center;background-color:'+ color +';width:100%;color:white">Localización <small style="margin-left:5px">'+titleReal+'</small><small style="margin-left:5px">'+titlePlan+'</small></span>' +
                '<div style="display:flex;justify-content:center;align-items:center;flex-direction:row;width:100%">'+
                  '<div style="flex:1;display:flex;justify-content:center;align-items:center;flex-direction:column">' +
                    '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;color:'+real_color+'" >- Pabellón: ' + numberFormatter(reales['pabellon (real)']) + ' ('+ (numberFormatter(reales['pabellon (real)']/(localizacion_total_reales) * 100)) +'%)</span>' +
                    '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;color:'+real_color+'">- Pajera: ' + numberFormatter(reales['pajera (real)']) + ' ('+ (numberFormatter(reales['pajera (real)']/(localizacion_total_reales) * 100)) +'%)</span>' +
                    '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;color:'+real_color+'">- Prov. Externo: ' + numberFormatter(reales['prov (real)']) + ' ('+ (numberFormatter(reales['prov (real)']/(localizacion_total_reales) * 100)) +'%)</span>' +
                  '</div>'+
                  '<div style="flex:1;display:flex;justify-content:center;align-items:center;flex-direction:column">' +
                    '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;color:'+color+'" >- Pabellón: ' + numberFormatter(planificados['pabellon (planificado)']) + ' ('+ (numberFormatter(planificados['pabellon (planificado)']/(localizacion_total_planificados) * 100)) +'%)</span>' +
                    '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;color:'+color+'">- Pajera: ' + numberFormatter(planificados['pajera (planificado)']) + ' ('+ (numberFormatter(planificados['pajera (planificado)']/(localizacion_total_planificados) * 100)) +'%)</span>' +
                    '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;color:'+color+'">- Prov. Externo: ' + numberFormatter(planificados['prov (planificado)']) + ' ('+ (numberFormatter(planificados['prov (planificado)']/(localizacion_total_planificados) * 100)) +'%)</span>' +
                  '</div>' +
                '</div>'
            } else {
              let localizacion = w.config.series[seriesIndex].aux
              let localizacion_total = localizacion[dataPointIndex].pabellon + localizacion[dataPointIndex].pajera + localizacion[dataPointIndex].prov
              let color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
              return '<div class="arrow_box" style="width:200px;height:115px;display:flex;justify-content:center;align-items:center;flex-direction:column;font-family:var(--roboto-medium)">' +
                '<span style="flex:0.75;display:flex;justify-content:center;align-items:center;background-color:'+ color +';width:100%;color:white">Localización</span>' +
                '<div style="flex:2;display:flex;justify-content:center;align-items:flex-start;flex-direction:column">' +
                  '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0" >- Pabellón: ' + numberFormatter(localizacion[dataPointIndex].pabellon) + ' ('+ (numberFormatter(localizacion[dataPointIndex].pabellon/(localizacion_total) * 100)) +'%)</span>' +
                  '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0">- Pajera: ' + numberFormatter(localizacion[dataPointIndex].pajera) + ' ('+ (numberFormatter(localizacion[dataPointIndex].pajera/(localizacion_total) * 100)) +'%)</span>' +
                  '<span style="font-size:12px;padding:0.25rem 0 0.25rem 0">- Prov. Externo: ' + numberFormatter(localizacion[dataPointIndex].prov) + ' ('+ (numberFormatter(localizacion[dataPointIndex].prov/(localizacion_total) * 100)) +'%)</span>' +
                '</div>'+
                '</div>'
            }
        },
      
        style : {
          fontSize: '14px',
          fontFamily: 'var(--roboto-medium)'
        },
        
      },
      
    },
  
  
  }

  export const STATE_INTERNAL_PROVIDERS_ENTRADA_INVENTARIO_STATE = {
          
    series: [],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false
        }, 
      },
      
      title : {
        text: "Stock Inicial de Acopios (Tm)",
        style : {
          fontSize: '14px',
          fontFamily: 'var(--roboto-medium)'
        }
        },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded',
          borderRadius: 5,
          dataLabels: {
            position:'top'
          },
        stacked:true,
        },
        
      },
      colors:[
        function(params:any) {
          let serie = params.seriesIndex
          
          
         
            
            if(serie === 0) {
              return 'rgba(10,10,44,0.3)'
            } else {
              return 'var(--lis-alternative)'
            }
          
 
        }
      ],
      dataLabels: {
        enabled: true,
        formatter : function (val:any,opts:any) {
          return numberFormatter(val)
        },
        offsetY: -25,
        
        style : {
          colors: ['var(--lis-dark)','var(--lis-alternative)'],
          
        },
        background: {
          enabled: true,
          foreColor: '#fff',
          borderRadius: 2,
          padding: 4,
          opacity: 0.5,
          borderWidth: 1,
          borderColor: '#fff'
        },
        
        

      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Ago 22','Sep 22', 'Oct 22', 'Nov 22', 'Dic 22', 'En 23', 'Feb 23', 'Mar 23', 'Abr 23', 'May 23','Jun 23', 'Jul 23'],
        labels: {
          style : {
            fontSize: '10px',
            fontFamily: 'var(--roboto-medium)'
          }
        }
      },
      yaxis: {
        labels : {
          formatter : function (value:any) {
            return numberFormatter(value)
          }
        },
        title: {
          text: 'Cantidad',
          
          style : {
            fontSize: '12px',
            fontFamily: 'var(--roboto-medium)'
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend : {
        fontSize: '12px',
        fontFamily: 'var(--roboto-light)',
        markers: {
          fillColors: ['var(--lis-dark)','var(--lis-alternative)'], 
      },
      },
      tooltip: {
        fixed : {
          enabled: true,
          position: 'bottomLeft',
          offsetY: -7
          
        },
        
        custom: function({series, seriesIndex, dataPointIndex, w}:any) {
          
          let auxiliar = w.config.series[seriesIndex].aux[dataPointIndex]
          let color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
          
          let render:any;
          let render2:any;
          let render3:any;

          if(auxiliar.length > 28*3) {
            render = auxiliar.slice(auxiliar.length - 25,auxiliar.length)?.map((a: any) => returnDefaultTables('warehouse',a,w,seriesIndex,dataPointIndex)).join('');  // Utiliza join para concatenar las filas y evitar comas adicionales


            return '<div class="arrow_box" style="width:333px;height:auto;display:flex;justify-content:space-around;align-items:flex-start;flex-direction:row;font-family:var(--roboto-medium)">' +
            '<table style="width:100%;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead>' +
            '<tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Almacén </th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            render +
            '<tr style="border:1px solid #ddd;padding:1px;font-size:12px"><td style="border:1px solid #ddd;padding:1px;color:blue">Para ver más, haz click <span style="text-decoration:underline;cursor:pointer;"><b>en la barra</b></span>.</td><td style="border:1px solid #ddd;padding:1px;"></td><td style="border:1px solid #ddd;padding:1px;"></td></tr>'+
            '</tbody>' +
            '</table>' +
            '</div>';
          } else if(auxiliar.length < 28*3 && auxiliar.length > 28*2) {
              const tercio = Math.ceil(auxiliar.length / 3);

              let reales = auxiliar.slice(0, tercio);
              let planificados = auxiliar.slice(tercio, tercio * 2)
              let delocos = auxiliar.slice(tercio * 2)
              render = reales?.map((a: any) => returnDefaultTables('warehouse',a,w,seriesIndex,dataPointIndex)).join('');  // Utiliza join para concatenar las filas y evitar comas adicionales
              
              render2 = planificados?.map((a: any) => returnDefaultTables('warehouse',a,w,seriesIndex,dataPointIndex)).join('');
    
              render3 = delocos?.map((a: any) => returnDefaultTables('warehouse',a,w,seriesIndex,dataPointIndex)).join('');

              return '<div class="arrow_box" style="width:1000px;height:auto;display:flex;justify-content:space-around;align-items:flex-start;flex-direction:row;font-family:var(--roboto-medium)">' +
            '<table style="width:90%;margin-right:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead>' +
            '<tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Almacén </th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            render +
            '</tbody>' +
            '</table>' +
            '<table style="width:90%;margin-left:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead><tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Almacén </th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '</tr></thead>' +
            '<tbody>' +
            render2 +
            '</tbody>' +
            '</table>' +
            '<table style="width:90%;margin-left:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead><tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Almacén </th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '</tr></thead>' +
            '<tbody>' +
            render3 +
            '</tbody>' +
            '</table>' +
            '</div>';
          } else if(auxiliar.length < 28*2 && auxiliar.length > 28) {
            const medio = Math.ceil(auxiliar.length / 2);

            let reales = auxiliar.slice(0, medio);
            let planificados = auxiliar.slice(medio, medio * 2)
            render = reales?.map((a: any) => returnDefaultTables('warehouse',a,w,seriesIndex,dataPointIndex)).join('');  // Utiliza join para concatenar las filas y evitar comas adicionales
            
            render2 = planificados?.map((a: any) => returnDefaultTables('warehouse',a,w,seriesIndex,dataPointIndex)).join('');

            return '<div class="arrow_box" style="width:666px;height:auto;display:flex;justify-content:space-around;align-items:flex-start;flex-direction:row;font-family:var(--roboto-medium)">' +
            '<table style="width:100%;margin-right:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead>' +
            '<tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Almacén </th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            render +
            '</tbody>' +
            '</table>' +
            '<table style="width:90%;margin-left:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead><tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Almacén </th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '</tr></thead>' +
            '<tbody>' +
            render2 +
            '</tbody>' +
            '</table>' +
            '</div>';
  
          } else {
            
            render = auxiliar?.map((a: any) => returnDefaultTables('warehouse',a,w,seriesIndex,dataPointIndex)).join('');  // Utiliza join para concatenar las filas y evitar comas adicionales


            return '<div class="arrow_box" style="width:333px;height:auto;display:flex;justify-content:space-around;align-items:flex-start;flex-direction:row;font-family:var(--roboto-medium)">' +
            '<table style="width:100%;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead>' +
            '<tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Almacén </th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            render +
            '</tbody>' +
            '</table>' +
            '</div>';
            
          }
          
        },
       
        
      
        style : {
          fontSize: '14px',
          fontFamily: 'var(--roboto-medium)'
        }
      },
    },
  
  
  }
  
  export const STATE_INTERNAL_PROVIDERS_WAREHOUSE_RANK_STATE = {
          
    series: [
      
    ],
    options: {
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
            show: false
          },
      },
      title : {
        text: "Ranking Pajeras por Stock Inicial (Tm)"
        },
      plotOptions: {
        bar: {
          horizontal: true,
        }
      },
      colors: ['var(--lis-dark)','var(--lis-alternative)'],
     
      dataLabels: {
        formatter: (val:any,opt:any) => formatCustom(val,opt) 
      },
      tooltip: {
        custom: function({series, seriesIndex, dataPointIndex, w}:any) {
         
          let auxiliar = w.config.series[0].data[dataPointIndex]
          
          let render = ''

          if('goals' in auxiliar) {
            render = 
            `<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;min-height:20px;display:flex;justify-content:center;align-items:center" ><div style="width:10px;height:10px;background-color:var(--lis-dark);border-radius:5px;margin-right:10px"></div>${numberFormatter(auxiliar.y)}</span>
            <span style="font-size:12px;padding:0.25rem 0 0.25rem 0;min-height:20px;display:flex;justify-content:center;align-items:center" ><div style="width:10px;height:10px;background-color:var(--lis-alternative);border-radius:5px;margin-right:10px"></div>${numberFormatter(auxiliar.goals[0].value)}</span>`
          
          } else {
            render = 
            `<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;min-height:20px;display:flex;justify-content:center;align-items:center" ><div style="width:10px;height:10px;background-color:var(--lis-dark);border-radius:5px;margin-right:10px"></div>${numberFormatter(auxiliar.y)}</span>`
          }

          
         
          return '<div class="arrow_box" style="width:175px;height:60px;display:flex;justify-content:center;align-items:center;flex-direction:column;font-family:var(--roboto-medium)">' +
            '<span style="flex:0.75;display:flex;justify-content:center;align-items:center;background-color:black;width:100%;color:white">Stock Inicial Pajeras</span>' +
            '<div style="flex:2;display:flex;justify-content:center;align-items:flex-start;flex-direction:column">' +
            render +
            '</div>'
        },
    },
        
      legend: {
        show: true,
        showForSingleSeries: true,
        fontSize: '12px',
        fontFamily: 'var(--roboto-light)',
        customLegendItems: ['Actual', 'Expected'],
        markers: {
          fillColors: ['var(--lis-dark)', 'var(--lis-alternative)']
        }
      }
    },
}

export const STATE_INTERNAL_PROVIDERS_NAVES_RANK_STATE = {
          
    series: [
      
    ],
    options: {
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
            show: false
          },
      },
      title : {
        text: "Ranking Naves por Stock Inicial (Tm)"
        },
      plotOptions: {
        bar: {
          horizontal: true,
        }
      },
      colors: ['var(--lis-dark)','var(--lis-alternative)'],
     
      dataLabels: {
        formatter: (val:any,opt:any) => formatCustom(val,opt)
      },
      tooltip: {
        custom: function({series, seriesIndex, dataPointIndex, w}:any) {
         
          let auxiliar = w.config.series[0].data[dataPointIndex]
          
          let render = ''

          if('goals' in auxiliar) {
            render = 
            `<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;min-height:20px;display:flex;justify-content:center;align-items:center" ><div style="width:10px;height:10px;background-color:var(--lis-dark);border-radius:5px;margin-right:10px"></div>${auxiliar.y}</span>
            <span style="font-size:12px;padding:0.25rem 0 0.25rem 0;min-height:20px;display:flex;justify-content:center;align-items:center" ><div style="width:10px;height:10px;background-color:var(--lis-alternative);border-radius:5px;margin-right:10px"></div>${auxiliar.goals[0].value}</span>`
          
          } else {
            render = 
            `<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;min-height:20px;display:flex;justify-content:center;align-items:center" ><div style="width:10px;height:10px;background-color:var(--lis-dark);border-radius:5px;margin-right:10px"></div>${auxiliar.y}</span>`
          }

          
         
          return '<div class="arrow_box" style="width:175px;height:60px;display:flex;justify-content:center;align-items:center;flex-direction:column;font-family:var(--roboto-medium)">' +
            '<span style="flex:0.75;display:flex;justify-content:center;align-items:center;background-color:black;width:100%;color:white">Stock Inicial Naves</span>' +
            '<div style="flex:2;display:flex;justify-content:center;align-items:flex-start;flex-direction:column">' +
            render +
            '</div>'
        },
    },
        
      legend: {
        show: true,
        showForSingleSeries: true,
        fontSize: '12px',
        fontFamily: 'var(--roboto-light)',
        customLegendItems: ['Actual', 'Expected'],
        markers: {
          fillColors: ['var(--lis-dark)', 'var(--lis-alternative)']
        }
      }
    },
}

export const STATE_EXTERNAL_PROVIDERS_DONUT = {
          
  series: [],
  options: {
  labels : [],
    chart: {
      type: 'donut',
    },
    title : {
        text: "Origen Biomasa (Tm)"
    },
    colors:['var(--lis-primary)','var(--lis-alternative)','#301934'],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom',
          fontSize: '12px',
          fontFamily: 'var(--roboto-light)',
        }
      }
    }],
    tooltip: {
      
      custom: function({series, seriesIndex, dataPointIndex, w}:any) {

        let compare = 'aux' in w.config? w.config.aux !== null? true : false : false
        
        let color = ''
        let render = ''

        if(compare) {
          let aux = w.config.aux[seriesIndex]
          
          color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
          render = aux.map((p:any) => {
            return `${p.provider}: ${numberFormatter(p.value)} (${numberFormatter((p.value / w.config.series[seriesIndex]) * 100)}%)`
            
          }).join('')

          
        } else {
          color = 'black'
          let proveedores = w.config.labels
          let series = w.config.series
          render = 
          `<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;min-height:20px;display:flex;justify-content:center;align-items:center" >${proveedores[seriesIndex]} : ${numberFormatter(series[seriesIndex])} (Tm)</span>`
        
        }
       
        return '<div class="arrow_box" style="width:500px;height:auto;display:flex;justify-content:center;align-items:center;flex-direction:column;font-family:var(--roboto-medium)">' +
          '<span style="display:flex;justify-content:center;align-items:center;background-color:'+ color +';width:100%;color:white">Proveedores Biomasa</span>' +
          '<div style="flex:2;display:flex;justify-content:center;align-items:flex-start;flex-direction:column;word-wrap: break-word;white-space: pre-wrap;width:480px;font-size:11px">' +
          render +
          '</div>'

          
      },
  },
    
  },


}

export const STATE_INTERNAL_PROVIDERS_ENTRADAS_STATE_REF = {
          
  series: [],
  options: {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false
      },
      
    },
    
    title : {
      text: "Entradas Proveedor Interno (Tm)",
      style : {
        fontSize: '14px',
        fontFamily: 'var(--roboto-medium)'
      }
      },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        borderRadius: 5,
        dataLabels: {
          position:'top'
        },
      stacked:true,
      },
      
    },
    colors:[
      (params:any) => colorsCustom(params)
    ],
    dataLabels: {
      enabled: true,
      formatter : function (val:any,opts:any) {
        return numberFormatter(val)
      },
      offsetY: -25,
      
      style : {
        colors: ['var(--lis-dark)','var(--lis-alternative)'],
        
      },
      background: {
        enabled: true,
        foreColor: '#fff',
        borderRadius: 2,
        padding: 4,
        opacity: 0.5,
        borderWidth: 1,
        borderColor: '#fff'
      },
      
      

    },
    
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Ago 22','Sep 22', 'Oct 22', 'Nov 22', 'Dic 22', 'En 23', 'Feb 23', 'Mar 23', 'Abr 23', 'May 23','Jun 23', 'Jul 23'],
      labels: {
        style : {
          fontSize: '10px',
          fontFamily: 'var(--roboto-medium)'
        }
      }
    },
    yaxis: {
      labels : {
        formatter : function (value:any) {
          return numberFormatter(value)
        }
      },
      title: {
        text: 'Cantidad',
        style : {
          fontSize: '12px',
          fontFamily: 'var(--roboto-medium)'
        }
      }
    },
    fill: {
      opacity: 1
    },
    legend : {
      fontSize: '12px',
      fontFamily: 'var(--roboto-light)',
      markers: {
        fillColors: ['var(--lis-dark)','var(--lis-alternative)'], 
    },
    },
    tooltip: {
      fixed : {
        enabled : true,
        position: 'bottomLeft'
      },
      custom: function({series, seriesIndex, dataPointIndex, w}:any) {
        let serie = seriesIndex
        let mes = dataPointIndex
        let meses = w.config.xaxis.categories
        let fecha_planificado = w.config.series[serie].planned_date
        let fecha_formateada = getMonthYearFromDate(fecha_planificado)

        let titleReal = getRangeReal(fecha_planificado)
        let titlePlanificado = getRangePlanificated(fecha_planificado)
            
        if(isSame(meses[mes],fecha_formateada)) {
          let auxiliar = w.config.series[seriesIndex].aux[dataPointIndex]
          let reales = auxiliar.filter((a:any) => a.categoria === 'real')
          let planificados = auxiliar.filter((a:any) => a.categoria === 'planificado')
          let render = reales?.map((a: any) => returnDefaultTables('provider',a,w,seriesIndex,dataPointIndex,true)).join('');  // Utiliza join para concatenar las filas y evitar comas adicionales
          
          let render2 = planificados?.map((a: any) => returnDefaultTables('provider',a,w,seriesIndex,dataPointIndex,true)).join('');
          
          let color = seriesIndex === 0 ? 'var(--lis-dark)' : 'var(--lis-alternative)';
          let real_color = seriesIndex === 0 ? 'var(--lis-dark)' : 'var(--lis-alternative)';
          
          return '<div class="arrow_box" style="width:1000px;height:auto;display:flex;justify-content:space-around;align-items:flex-start;flex-direction:row;font-family:var(--roboto-medium)">' +
            '<table style="width:90%;margin-right:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead>' +
            '<tr style="background-color:' + real_color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Prov. Interno <small>'+titleReal+'</small></th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tipo</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            render +
            '</tbody>' +
            '</table>' +
            '<table style="width:90%;margin-left:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead><tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Prov. Interno <small>'+titlePlanificado+'</small></th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tipo</th>' +
            '</tr></thead>' +
            '<tbody>' +
            render2 +
            '</tbody>' +
            '</table>' +
            '</div>';
          
        } else {
          let auxiliar = w.config.series[seriesIndex].aux[dataPointIndex]
          let color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
          
          let render = auxiliar?.map((a: any) => returnDefaultTables('provider',a,w,seriesIndex,dataPointIndex,false));

          // Crear el tbody fuera del bucle y llenarlo con las filas generadas
          const tbody = '<tbody>' + render.join('') + '</tbody>';
          
          // Construir la cadena completa
          return '<div class="arrow_box" style="width:500px;height:auto;display:flex;justify-content:flex-start;align-items:center;flex-direction:column;font-family:var(--roboto-medium)">' +
            '<table style="width:100%;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead><tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Prov. Interno</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '</tr></thead>' +
            tbody +
            '</table>' +
            '</div>';
        }
       
      },
     
      
    
      style : {
        fontSize: '14px',
        fontFamily: 'var(--roboto-medium)'
      }
    },
  },


}

export const STATE_EXTERNAL_PROVIDERS_ENTRADAS_STATE = {
          
  series: [],
  options: {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false
      },
      
    },
    
    title : {
      text: "Entradas Proveedor Externo (Tm)",
      style : {
        fontSize: '14px',
        fontFamily: 'var(--roboto-medium)'
      }
      },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        borderRadius: 5,
        dataLabels: {
          position:'top'
        },
      stacked:true,
      },
      
    },
    colors:[
      (params:any) => colorsCustom(params)
    ],
    dataLabels: {
      enabled: true,
      formatter : function (val:any,opts:any) {
        return numberFormatter(val)
      },
      offsetY: -25,
      
      style : {
        colors: ['var(--lis-dark)','var(--lis-alternative)'],
        
      },
      background: {
        enabled: true,
        foreColor: '#fff',
        borderRadius: 2,
        padding: 4,
        opacity: 0.5,
        borderWidth: 1,
        borderColor: '#fff'
      },
      
      

    },
    
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Ago 22','Sep 22', 'Oct 22', 'Nov 22', 'Dic 22', 'En 23', 'Feb 23', 'Mar 23', 'Abr 23', 'May 23','Jun 23', 'Jul 23'],
      labels: {
        style : {
          fontSize: '10px',
          fontFamily: 'var(--roboto-medium)'
        }
      }
    },
    yaxis: {
      labels : {
        formatter : function (value:any) {
          return numberFormatter(value)
        }
      },
      title: {
        text: 'Cantidad',
        style : {
          fontSize: '12px',
          fontFamily: 'var(--roboto-medium)'
        }
      }
    },
    fill: {
      opacity: 1
    },
    legend : {
      fontSize: '12px',
      fontFamily: 'var(--roboto-light)',
      markers: {
        fillColors: ['var(--lis-dark)','var(--lis-alternative)'], 
    },
    },
    tooltip: {
      fixed: {
        enabled: true,
        position:'bottomLeft',
        
      },
      
      custom: function({series, seriesIndex, dataPointIndex, w}:any) {
        let serie = seriesIndex
        let mes = dataPointIndex
        let meses = w.config.xaxis.categories
        let fecha_planificado = w.config.series[serie].planned_date
        let fecha_formateada = getMonthYearFromDate(fecha_planificado)

        let titleReal = getRangeReal(fecha_planificado)
        let titlePlanificado = getRangePlanificated(fecha_planificado)
            
        if(isSame(meses[mes],fecha_formateada)) {
          let auxiliar = w.config.series[seriesIndex].aux[dataPointIndex]
          let reales = auxiliar.filter((a:any) => a.categoria === 'real')
          let planificados = auxiliar.filter((a:any) => a.categoria === 'planificado')
          let render = reales?.map((a: any) => returnDefaultTables('provider',a,w,seriesIndex,dataPointIndex,true)).join('');  // Utiliza join para concatenar las filas y evitar comas adicionales
          
          let render2 = planificados?.map((a: any) => returnDefaultTables('provider',a,w,seriesIndex,dataPointIndex,true)).join('');
          
          let color = seriesIndex === 0 ? 'var(--lis-dark)' : 'var(--lis-alternative)';
          let real_color = seriesIndex === 0 ? 'var(--lis-dark)' : 'var(--lis-alternative)';
          
          return '<div class="arrow_box" style="width:1000px;height:auto;display:flex;justify-content:space-around;align-items:flex-start;flex-direction:row;font-family:var(--roboto-medium)">' +
            '<table style="width:90%;margin-right:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead>' +
            '<tr style="background-color:' + real_color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Prov. Externo <small>'+titleReal+'</small></th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tipo</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            render +
            '</tbody>' +
            '</table>' +
            '<table style="width:90%;margin-left:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead><tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Prov. Externo <small>'+titlePlanificado+'</small></th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tipo</th>' +
            '</tr></thead>' +
            '<tbody>' +
            render2 +
            '</tbody>' +
            '</table>' +
            '</div>';

        } else {
          let auxiliar = w.config.series[seriesIndex].aux[dataPointIndex]
          let color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
          
          let render = auxiliar?.map((a: any) => returnDefaultTables('provider',a,w,seriesIndex,dataPointIndex,false));
          
          // Crear el tbody fuera del bucle y llenarlo con las filas generadas
          const tbody = '<tbody>' + render.join('') + '</tbody>';
          
          // Construir la cadena completa
          return '<div class="arrow_box" style="width:500px;height:auto;display:flex;justify-content:flex-start;align-items:center;flex-direction:column;font-family:var(--roboto-medium)">' +
            '<table style="width:100%;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead><tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Prov. Externo</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '</tr></thead>' +
            tbody +
            '</table>' +
            '</div>';
        }
        
      },
     
      
    
      style : {
        fontSize: '14px',
        fontFamily: 'var(--roboto-medium)'
      }
    },
  },


}

export const STATE_INTERNAL_PROVIDERS_ENTRADAS_STATE = {
          
  series: [],
  options: {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false
      },
      
    },
    
    title : {
      text: "Salidas Proveedor Interno (Tm)",
      style : {
        fontSize: '14px',
        fontFamily: 'var(--roboto-medium)'
      }
      },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        borderRadius: 5,
        
      stacked:true,
      },
      
    },
    colors:[
      (params:any) => colorsCustom(params)
    ],
    dataLabels: {
      enabled: true,
      formatter : function (val:any,opts:any) {
        return numberFormatter(val)
      },
      offsetY: -25,
      
      style : {
        colors: ['var(--lis-dark)','var(--lis-alternative)'],
        
      },
      background: {
        enabled: true,
        foreColor: '#fff',
        borderRadius: 2,
        padding: 4,
        opacity: 0.5,
        borderWidth: 1,
        borderColor: '#fff'
      },
      
      

    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Ago 22','Sep 22', 'Oct 22', 'Nov 22', 'Dic 22', 'En 23', 'Feb 23', 'Mar 23', 'Abr 23', 'May 23','Jun 23', 'Jul 23'],
      labels: {
        style : {
          fontSize: '10px',
          fontFamily: 'var(--roboto-medium)'
        }
      }
    },
    yaxis: {
      title: {
        text: 'Cantidad',
        style : {
          fontSize: '12px',
          fontFamily: 'var(--roboto-medium)'
        }
      }
    },
    fill: {
      opacity: 1
    },
    legend : {
      fontSize: '12px',
      fontFamily: 'var(--roboto-light)',
      markers: {
        fillColors: ['var(--lis-dark)','var(--lis-alternative)'], 
    },
    },
    tooltip: {
      custom: function({series, seriesIndex, dataPointIndex, w}:any) {
        let serie = seriesIndex
        let mes = dataPointIndex
        let meses = w.config.xaxis.categories
        let fecha_planificado = w.config.series[serie].planned_date
        let fecha_formateada = getMonthYearFromDate(fecha_planificado)

        let title = getRangeReal(fecha_planificado)
            
        if(isSame(meses[mes],fecha_formateada)) {
          let auxiliar = w.config.series[seriesIndex].aux[dataPointIndex]
          let reales = auxiliar.filter((a:any) => a.categoria === 'real')
          let planificados = auxiliar.filter((a:any) => a.categoria === 'planificado')
          let render = reales?.map((a:any) => {
            return `${a.provider}: ${numberFormatter(a.value)} (${numberFormatter((a.value / w.config.series[seriesIndex].data[dataPointIndex]) * 100)}%)`
          }).join(',')
          let render2 = planificados?.map((a:any) => {
            return `${a.provider}: ${numberFormatter(a.value)} (${numberFormatter((a.value / w.config.series[seriesIndex].data[dataPointIndex]) * 100)}%)`
          }).join(',')
          
          let color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
          let real_color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
          return '<div class="arrow_box" style="width:400px;height:auto;display:flex;justify-content:center;align-items:center;flex-direction:column;font-family:var(--roboto-medium);">' +
          '<span style="display:flex;justify-content:space-around;align-items:center;background-color:'+ color +';width:100%;color:white;height:30px">Proveedores Internos <small>'+title+'</small></span>' +
          '<div style="flex:2;display:flex;justify-content:flex-start;align-items:flex-start;flex-direction:column;word-wrap: break-word;white-space: pre-wrap;width:380px;font-size:11px">' +
          '<span style="color:'+real_color+';">'+render+'</span><span style="color:'+color+';">'+render2+'</span>'+
          '</div>'
          
        } else {
          let auxiliar = w.config.series[seriesIndex].aux[dataPointIndex]

        let render = auxiliar?.map((a:any) => {
          return `${a.provider}: ${numberFormatter(a.value)} (${numberFormatter((a.value / w.config.series[seriesIndex].data[dataPointIndex]) * 100)}%)`
          /*return (
            `<span style="font-size:12px;padding:0.25rem 0 0.25rem 0;min-height:20px" >${a.provider}: ${a.value} (${((a.value / w.config.series[seriesIndex].data[dataPointIndex]) * 100).toFixed(2)}%)</span>`
          )*/
        }).join(',')

        
        let color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
        return '<div class="arrow_box" style="width:400px;height:auto;display:flex;justify-content:center;align-items:center;flex-direction:column;font-family:var(--roboto-medium);">' +
          '<span style="display:flex;justify-content:center;align-items:center;background-color:'+ color +';width:100%;color:white;height:30px">Proveedores Internos</span>' +
          '<div style="flex:2;display:flex;justify-content:flex-start;align-items:flex-start;flex-direction:column;word-wrap: break-word;white-space: pre-wrap;width:380px;font-size:11px">' +
            render +
          '</div>'
        }
        
      },
     
      
    
      style : {
        fontSize: '14px',
        fontFamily: 'var(--roboto-medium)'
      }
    },
  },


}

export const STATE_TRANSPORTE = {
          
  series: [],
  options: {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false
      },
      
    },
    
    title : {
      text: "Mix Biomasa por Transportista (Tm)",
      style : {
        fontSize: '14px',
        fontFamily: 'var(--roboto-medium)'
      }
      },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        borderRadius: 5,
        dataLabels: {
          position:'top'
        },
      stacked:true,
      },
      
    },
    colors:[
      (params:any) => colorsCustom(params)
    ],
    dataLabels: {
      enabled: true,
      formatter : function (val:any,opts:any) {
        return numberFormatter(val)
      },
      offsetY: -25,
      
      style : {
        colors: ['var(--lis-dark)','var(--lis-alternative)'],
        
      },
      background: {
        enabled: true,
        foreColor: '#fff',
        borderRadius: 2,
        padding: 4,
        opacity: 0.5,
        borderWidth: 1,
        borderColor: '#fff'
      },
      
      

    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Ago 22','Sep 22', 'Oct 22', 'Nov 22', 'Dic 22', 'En 23', 'Feb 23', 'Mar 23', 'Abr 23', 'May 23','Jun 23', 'Jul 23'],
      labels: {
        style : {
          fontSize: '10px',
          fontFamily: 'var(--roboto-medium)'
        }
      }
    },
    yaxis: {
      labels : {
        formatter : function (value:any) {
          return numberFormatter(value)
        }
      },
      title: {
        text: 'Cantidad',
        style : {
          fontSize: '12px',
          fontFamily: 'var(--roboto-medium)'
        }
      }
    },
    fill: {
      opacity: 1
    },
    legend : {
      fontSize: '12px',
      fontFamily: 'var(--roboto-light)',
      markers: {
        fillColors: ['var(--lis-dark)','var(--lis-alternative)'], 
    },
    },
    tooltip: {
      fixed : {
        enabled: true,
        position: 'bottomLeft',
      },
      custom: function({series, seriesIndex, dataPointIndex, w}:any) {
        let serie = seriesIndex
        let mes = dataPointIndex
        let meses = w.config.xaxis.categories
        let fecha_planificado = w.config.series[serie].planned_date
        let fecha_formateada = getMonthYearFromDate(fecha_planificado)

        let titleReal = getRangeReal(fecha_planificado)
        let titlePlanificado = getRangePlanificated(fecha_planificado)
            
        if(isSame(meses[mes],fecha_formateada)) {
          let auxiliar = w.config.series[seriesIndex].aux[dataPointIndex]

          
          let reales = auxiliar.filter((a:any) => a.categoria === 'real')
          let planificados = auxiliar.filter((a:any) => a.categoria === 'planificado')
          let render = reales?.map((a: any) => returnDefaultTables('transportista',a,w,seriesIndex,dataPointIndex,true)).join('');  // Utiliza join para concatenar las filas y evitar comas adicionales
          
          let render2 = planificados?.map((a: any) => returnDefaultTables('transportista',a,w,seriesIndex,dataPointIndex,true)).join('');
          
          let color = seriesIndex === 0 ? 'var(--lis-dark)' : 'var(--lis-alternative)';
          let real_color = seriesIndex === 0 ? 'var(--lis-dark)' : 'var(--lis-alternative)';
          
          return '<div class="arrow_box" style="width:1000px;height:auto;display:flex;justify-content:space-around;align-items:flex-start;flex-direction:row;font-family:var(--roboto-medium)">' +
            '<table style="width:90%;margin-right:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead>' +
            '<tr style="background-color:' + real_color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Transportistas <small>'+titleReal+'</small></th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tipo</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            render +
            '</tbody>' +
            '</table>' +
            '<table style="width:90%;margin-left:5px;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead><tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Transportistas <small>'+titlePlanificado+'</small></th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tipo</th>' +
            '</tr></thead>' +
            '<tbody>' +
            render2 +
            '</tbody>' +
            '</table>' +
            '</div>';
        } else {

          let auxiliar = w.config.series[seriesIndex].aux[dataPointIndex]
          let color = seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)'
          
          let render = auxiliar?.map((a: any) => returnDefaultTables('transportista',a,w,seriesIndex,dataPointIndex,false));
          
          // Crear el tbody fuera del bucle y llenarlo con las filas generadas
          const tbody = '<tbody>' + render.join('') + '</tbody>';
          
          // Construir la cadena completa
          return '<div class="arrow_box" style="width:500px;height:auto;display:flex;justify-content:flex-start;align-items:center;flex-direction:column;font-family:var(--roboto-medium)">' +
            '<table style="width:100%;border-collapse:collapse;border:1px solid #ddd;">' +
            '<thead><tr style="background-color:' + color + ';color:white;font-size:var(--roboto-light)">' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Transportistas</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">Tm</th>' +
            '<th style="border:1px solid #ddd;padding:5px;text-align:left;">% Ratio</th>' +
            '</tr></thead>' +
            tbody +
            '</table>' +
            '</div>';
         
        }
         
      },
     
      
    
      style : {
        fontSize: '14px',
        fontFamily: 'var(--roboto-medium)'
      }
    },
  },


}